import { BaseError } from './errors';

export class InternalError extends BaseError {}
